// extracted by mini-css-extract-plugin
module.exports = {"root":"NavBar_root__efDNW","isSticky-true":"NavBar_isSticky-true__dtxkB","slide-in":"NavBar_slide-in__eKz6V"};